import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c81de486"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["placeholder"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "search-icon icf-magnify" }, null, -1))

import { ACTION } from '@gd/tracking'
import { track } from '@/lib/track'
import { ref } from 'vue'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'CSearchInput',
  props: {
    placeholder: { default: '' }
  },
  emits: ['on-change'],
  setup(__props: any, { emit: __emit }) {


const emit = __emit
const route = useRoute()
const data = ref('')
// since the search (aka "update") function is triggered on every character that is entered,
// we decided to track only once if the search has been used
const searchTracked = ref(false)

function update(value: string) {
  data.value = value
  emit('on-change', value)
}

function onChange(event: KeyboardEvent) {
  const searchTerm = (event.target as HTMLInputElement).value
  update(searchTerm)
  if (!searchTracked.value) {
    searchTracked.value = true
    track({
      id: 'search_input',
      path: route.fullPath,
      action: ACTION.change,
    })
  }
}

function onClear(event: MouseEvent) {
  update('')
  track({
    id: 'search_input',
    path: route.fullPath,
    action: ACTION.clear,
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['t-filter-group', { 't-filter-group--clear': data.value.length > 0 }])
  }, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      placeholder: _ctx.placeholder,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data).value = $event)),
      onKeyup: onChange
    }, null, 40, _hoisted_1), [
      [_vModelText, data.value]
    ]),
    _createElementVNode("div", {
      class: "clear-icon icf-close",
      onClick: onClear
    }),
    _hoisted_2
  ], 2))
}
}

})